import React from 'react';
import classnames from 'classnames';
import {
  Popover,
  PopoverDisclosure,
  PopoverProps,
  usePopoverState,
  PopoverInitialState,
} from 'reakit/Popover';

export interface CKPopoverProps extends PopoverProps {
  isFullWidth?: boolean;
  className?: string;
  children: React.ReactElement;
  popover: React.ReactNode;
  options?: PopoverInitialState;
}

export const CKPopover: React.FC<CKPopoverProps> = ({
  children,
  isFullWidth,
  className,
  options,
  popover,
  ...rest
}) => {
  const popoverState = usePopoverState(options);
  const popoverClass = classnames('ck-popover', className, {
    'ck-popover--full-width': isFullWidth,
  });

  return (
    <React.Fragment>
      <PopoverDisclosure
        {...popoverState}
        {...children.props}
        // @ts-ignore
        ref={children.ref}
      >
        {disclosureProps => React.cloneElement(children, disclosureProps)}
      </PopoverDisclosure>
      <Popover {...rest} {...popoverState}>
        {({ className, ...htmlProps }) => (
          <div className={popoverClass} {...htmlProps}>
            {popover}
          </div>
        )}
      </Popover>
    </React.Fragment>
  );
};

export const CKPopoverMenu: React.FC = ({ children }) => {
  return <div className="ck-popover-menu">{children}</div>;
};

export const CKPopoverDivider = () => <hr className="ck-popover-divider" />;

export interface CKPopoverMenuItemProps {
  icon?: React.ReactNode;
  isDestructive?: boolean;
}

export interface CKPopoverMenuLinkProps
  extends CKPopoverMenuItemProps,
    React.AnchorHTMLAttributes<HTMLAnchorElement> {}

export const CKPopoverMenuLink: React.FC<CKPopoverMenuLinkProps> = ({
  children,
  href,
  target,
  rel,
  icon,
  isDestructive,
  ...rest
}) => {
  const itemClass = classnames('ck-popover-menu-item', {
    'ck-popover-menu-item--destroy': isDestructive,
  });
  return (
    <a className={itemClass} href={href} target={target} rel={rel} {...rest}>
      {icon && <span className="ck-popover-menu-item-icon">{icon}</span>}
      <span>{children}</span>
    </a>
  );
};
